// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"362":"bf35ec56","512":"0c0fca49","821":"bf35ec56","924":"bf35ec56"}[chunkId] + ".chunk.css";
};